import { differenceInCalendarDays, format, formatDistanceToNowStrict, parseISO } from 'date-fns';

export const fmtDate = (iso: string | null | undefined): string => (iso ? format(parseISO(iso), 'MMM d, yyyy') : '—');
export const fmtShort = (iso: string | null | undefined): string => (iso ? format(parseISO(iso), 'MMM d') : '—');

/** "Today", "3 days ago", "in 2 weeks": whole days up to two months, then months. */
export const relativeDay = (iso: string | null | undefined, now: Date = new Date()): string => {
  if (!iso) return '';
  const d = parseISO(iso);
  const n = differenceInCalendarDays(d, now);
  if (n === 0) return 'Today';
  if (n === 1) return 'Tomorrow';
  if (n === -1) return 'Yesterday';
  if (Math.abs(n) < 60) return n < 0 ? `${-n} days ago` : `in ${n} days`;
  return formatDistanceToNowStrict(d, { addSuffix: true });
};

/** 45 -> "45m", 90 -> "1h 30m", 120 -> "2h". Empty for zero or unknown. */
export const fmtMinutes = (n: number | null | undefined): string => {
  if (!n || n <= 0) return '';
  if (n < 60) return `${Math.round(n)}m`;
  const h = Math.floor(n / 60);
  const m = Math.round(n % 60);
  return m ? `${h}h ${m}m` : `${h}h`;
};
